import { I18nThemed } from 'interfaces/mixins';
import { DNode } from '@dojo/framework/core/interfaces';
import { v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';

import { FormThanks as IFormThanks } from '../interfaces';
import css from '../css/document.m.css';

export interface FormThanksProperties extends IFormThanks {}

@theme(css)
export class FormThanksPage extends I18nThemed<FormThanksProperties> {
	protected render_prologue(): DNode {
		const { thanksPrologue } = this.properties;
		if (thanksPrologue.data.length > 0) {
			return v('div', { innerHTML: thanksPrologue.data });
		}
		return null;
	}

	protected render_epilogue(): DNode {
		const { thanksEpilogue } = this.properties;
		if (thanksEpilogue.data.length > 0) {
			return v('div', { innerHTML: thanksEpilogue.data });
		}
		return null;
	}

	protected render(): DNode {
		const { title, description } = this.properties;
		return v('div', { classes: [this.theme(css.root)] }, [
			v('h1', { classes: [this.theme(css.heading)] }, [title]),
			v('article', { classes: [this.theme(css.article)] }, [
				v('p', {}, [description && description.data]),
				this.render_prologue(),
				this.render_epilogue()
			])
		]);
	}
}
